import { TextField as MuiTextField } from "@material-ui/core";
import { rv } from "../../tokens";
import FieldShell from "./FieldShell";

interface Props {
  label?: string;
  value: string | undefined;
  onChange: (value: string) => void;
  error?: string;
  required?: boolean;
  disabled?: boolean;
  min?: string; // earliest selectable date (YYYY-MM-DD)
  max?: string; // latest selectable date (YYYY-MM-DD)
}

// Native date input; stores/returns the strict YYYY-MM-DD the API expects.
export default function DateField({
  label,
  value,
  onChange,
  error,
  required,
  disabled,
  min,
  max,
}: Props) {
  return (
    <FieldShell label={label} required={required} error={error}>
      <MuiTextField
        variant="outlined"
        size="small"
        fullWidth
        type="date"
        value={value ?? ""}
        disabled={disabled}
        error={Boolean(error)}
        InputLabelProps={{ shrink: true }}
        inputProps={{ min, max, style: { fontFamily: rv.fontSans } }}
        onChange={(event) => onChange(event.target.value)}
      />
    </FieldShell>
  );
}
